import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { createTimer } from '../timing';
export const ConfigReady = createTimer('ConfigReady');
export const config = (configure) => (pre) => {
    pre.record(ConfigReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield configure(ctx);
        ctx.done(ConfigReady);
    });
};
//# sourceMappingURL=config.js.map